// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PageContentWrapper-module_wrapper_ZAo3s2K1MTZynHHbrace{flex:1 1 auto}", "",{"version":3,"sources":["webpack://./src/components/PageContentWrapper/PageContentWrapper.module.scss"],"names":[],"mappings":"AACA,wDACE,aAAA","sourcesContent":["@import \"src/styles/theme.scss\";@import \"~@crunchyroll/cx-web-themes/crunchyroll/abstracts/main\";\n.wrapper {\n  flex: 1 1 auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "PageContentWrapper-module_wrapper_ZAo3s2K1MTZynHHbrace"
};
export default ___CSS_LOADER_EXPORT___;
